import { BeyondContentTooltipComponent } from './beyond-content-tooltip.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';

@NgModule({
    declarations: [BeyondContentTooltipComponent],
    imports: [CommonModule, FormsModule, NzCheckboxModule, NzToolTipModule],
    exports: [BeyondContentTooltipComponent],
})
export class BeyondContentTooltipModule {}
